export const siteSlice = (set,get) =>({
    isSidebarOpen:true,
    clinicId:1,
    user:{},
    selectedUser:{},
    toggleSidebar: () =>set((state)=>({isSidebarOpen:!state.isSidebarOpen})),
    setClinicId :(newclinicId) => set((state)=>({clinicId:newclinicId})),
    setUser : (newUser) => set((state)=>({user : newUser})),
    setSelectedUser:(newSelectedUser) => set((state)=>({selectedUser : newSelectedUser}))
})